import { render, staticRenderFns } from "./CountCollectionTaskDispense.vue?vue&type=template&id=2018af59&scoped=true"
import script from "./CountCollectionTaskDispense.vue?vue&type=script&lang=js"
export * from "./CountCollectionTaskDispense.vue?vue&type=script&lang=js"
import style0 from "./CountCollectionTaskDispense.vue?vue&type=style&index=0&id=2018af59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2018af59",
  null
  
)

export default component.exports